<div id="page-nav-header" class="page-nav-header" *ngIf="innerWidth>992 && (activeTabItem === 'overview' || activeTabItem === 'performance-fees' || activeTabItem === 'price' || activeTabItem === 'portfolio-composition' ||
       activeTabItem === 'distributions' || activeTabItem === 'fund-management' || activeTabItem === 'proxy-voting' || activeTabItem === 'fund-literature' || activeTabItem === 'disclosures')">
    <div class="container">
        <div class="page-nav-header-content">
            <div style="display: flex; width: 900px;" [ngClass]="{'pad-bottom' : (navTabGroupModel?.is529) }">
                <p class="sticky-ticker">{{navTabGroupModel?.ticker ? navTabGroupModel.ticker : (navTabGroupModel?.is529 ? '529 Portfolio': '&mdash;')}}</p>
                <p class="sticky-fund-name">{{navTabGroupModel?.fundName ? navTabGroupModel.fundName : '&mdash;'}}</p>
            </div>
            <div class="buttons-box">
              <buy-button *ngIf="isBuyAvailable()" class="btn" [fundInput]='navTabGroupModel' size="small"></buy-button>
              <compare-button *ngIf="isCompareAvailable()" class="btn compare" [fundInput]='navTabGroupModel' size="small"></compare-button>
            </div>
        </div>
    </div>
</div>
<div class="secondary-nav" (window:resize)="detectScreenSize()">
    <div class="container" *ngIf="innerWidth>992">
        <div id="secondary-nav-items" [activeTab]="activeTabItem" [ngStyle]="{'margin-top':innerWidth>992 && (activeTabItem === 'overview' || activeTabItem === 'performance-fees' || activeTabItem === 'price' || activeTabItem === 'portfolio-composition' ||
            activeTabItem === 'distributions' || activeTabItem === 'fund-management' || activeTabItem === 'proxy-voting' || activeTabItem === 'fund-literature' || activeTabItem === 'disclosures') ? '2rem' : '0', 'margin-bottom':innerWidth>992 && (activeTabItem === 'overview' || activeTabItem === 'performance-fees' || activeTabItem === 'price' || activeTabItem === 'portfolio-composition' ||
            activeTabItem === 'distributions' || activeTabItem === 'fund-management' || activeTabItem === 'proxy-voting' || activeTabItem === 'fund-literature' || activeTabItem === 'disclosures') ? '2rem' : '0' }">
            <a class="tab-item" href="javascript:void(0)" role="button" (click)="scrollToTab('overview')" aria-label="Overview" id="overview-tab">Overview</a>
            <a class="tab-item" href="javascript:void(0)" role="button" (click)="scrollToTab('performance-fees')" aria-label="Performance & fees" id="performance-fees-tab">Performance & fees</a>
            <a class="tab-item" href="javascript:void(0)" role="button" (click)="scrollToTab('price')" aria-label="Price" id="price-tab">Price</a>
            <a class="tab-item" href="javascript:void(0)" role="button" (click)="scrollToTab('portfolio-composition')" aria-label="Portfolio composition" id="portfolio-composition-tab">Portfolio composition</a>
            <a *ngIf="!(navTabGroupModel?.is529 || navTabGroupModel?.isExternalFund)" class="tab-item" href="javascript:void(0)" role="button" (click)="scrollToTab('distributions')" aria-label="Distributions" id="distributions-tab">Distributions</a>
            <a *ngIf="!navTabGroupModel?.isExternalFund" class="tab-item" href="javascript:void(0)" role="button" (click)="scrollToTab('fund-management')" aria-label="Fund management" id="fund-management-tab">Fund management</a>
            <a *ngIf="hasProxyVotingContent" class="tab-item" href="javascript:void(0)" role="button" (click)="scrollToTab('proxy-voting')" aria-label="Proxy voting" id="proxy-voting-tab">Proxy voting</a>
            <a *ngIf="!(navTabGroupModel?.is529 || navTabGroupModel?.isExternalFund)" class="tab-item" href="javascript:void(0)" role="button" (click)="scrollToTab('fund-literature')" aria-label="Fund literature" id="fund-literature-tab">Fund literature</a>
        </div>
    </div>
</div>

<div class="mobile-view" *ngIf="innerWidth<=992">
    <!-- Overview -->
    <div class="c11n-accordion c11n-accordion--medium
        c11n-accordion--bold-weight
        c11n-accordion--trailing">
      <h2>
        <button type="button" class="c11n-accordion__trigger c11n-accordion__trigger-medium"
          aria-expanded="false"
          title="show more"
          (click)="toggleAccordion('overview')">
            <span class="c11n-accordion__trigger-items container">
                <span class="c11n-accordion__heading-group">
                    <span class="c11n-accordion__heading">
                        <span>Overview</span>
                    </span>
                </span>

                <span class="c11n-accordion__icon">
                    <svg id="overview-caret-down" class="c11n-caret-down-small" aria-hidden="true">
                        <use xlink:href="#caret-down-small"></use>
                    </svg>
                    <svg id="overview-caret-up" class="hidden c11n-caret-up-small" aria-hidden="true">
                        <use xlink:href="#caret-up-small"></use>
                    </svg>
                </span>

            </span>
        </button>
      </h2>
      <div id="overview-body" class="c11n-accordion__body">
        <div class="c11n-accordion__body-content">
          <div class="c11n-accordion-story-content">
            <div class="c11n-text-md--crop c11n-link--reinforced">
              <overview></overview>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Performance & fees -->
    <div class="c11n-accordion c11n-accordion--medium
        c11n-accordion--bold-weight
        c11n-accordion--trailing">
      <h2>
        <button type="button" class="c11n-accordion__trigger c11n-accordion__trigger-medium"
          id="performance-and-fees-accordion"
          aria-expanded="false"
          title="show more"
          (click)="toggleAccordion('performance')">
            <span class="c11n-accordion__trigger-items container">
                <span class="c11n-accordion__heading-group">
                    <span class="c11n-accordion__heading">
                        <span>Performance & fees</span>
                    </span>
                </span>

                <span class="c11n-accordion__icon">
                    <svg id="performance-caret-down" class="c11n-caret-down-small" aria-hidden="true">
                        <use xlink:href="#caret-down-small"></use>
                    </svg>
                    <svg id="performance-caret-up" class="hidden c11n-caret-up-small" aria-hidden="true">
                        <use xlink:href="#caret-up-small"></use>
                    </svg>
                </span>

            </span>
        </button>
      </h2>
      <div id="performance-body" class="c11n-accordion__body">
        <div class="c11n-accordion__body-content">
          <div class="c11n-accordion-story-content">
            <div class="c11n-text-md--crop c11n-link--reinforced">
              <performance></performance>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Price -->
    <div class="c11n-accordion c11n-accordion--medium
        c11n-accordion--bold-weight
        c11n-accordion--trailing">
      <h2>
        <button type="button" class="c11n-accordion__trigger c11n-accordion__trigger-medium"
          aria-expanded="false"
          title="show more"
          (click)="toggleAccordion('price')">
            <span class="c11n-accordion__trigger-items container">
                <span class="c11n-accordion__heading-group">
                    <span class="c11n-accordion__heading">
                        <span>Price</span>
                    </span>
                </span>

                <span class="c11n-accordion__icon">
                    <svg id="price-caret-down" class="c11n-caret-down-small" aria-hidden="true">
                        <use xlink:href="#caret-down-small"></use>
                    </svg>
                    <svg id="price-caret-up" class="hidden c11n-caret-up-small" aria-hidden="true">
                        <use xlink:href="#caret-up-small"></use>
                    </svg>
                </span>

            </span>
        </button>
      </h2>
      <div id="price-body" class="c11n-accordion__body">
        <div class="c11n-accordion__body-content">
          <div class="c11n-accordion-story-content">
            <div class="c11n-text-md--crop c11n-link--reinforced">
              <price></price>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Portfolio composition -->
    <div class="c11n-accordion c11n-accordion--medium
        c11n-accordion--bold-weight
        c11n-accordion--trailing">
      <h2>
        <button type="button" class="c11n-accordion__trigger c11n-accordion__trigger-medium"
          aria-expanded="false"
          title="show more"
          (click)="toggleAccordion('portfolio')">
            <span class="c11n-accordion__trigger-items container">
                <span class="c11n-accordion__heading-group">
                    <span class="c11n-accordion__heading">
                        <span>Portfolio composition</span>
                    </span>
                </span>

                <span class="c11n-accordion__icon">
                    <svg id="portfolio-caret-down" class="c11n-caret-down-small" aria-hidden="true">
                        <use xlink:href="#caret-down-small"></use>
                    </svg>
                    <svg id="portfolio-caret-up" class="hidden c11n-caret-up-small" aria-hidden="true">
                        <use xlink:href="#caret-up-small"></use>
                    </svg>
                </span>

            </span>
        </button>
      </h2>
      <div id="portfolio-body" class="c11n-accordion__body">
        <div class="c11n-accordion__body-content">
          <div class="c11n-accordion-story-content">
            <div class="c11n-text-md--crop c11n-link--reinforced">
              <portfolio></portfolio>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Distributions -->
    <div class="c11n-accordion c11n-accordion--medium
        c11n-accordion--bold-weight
        c11n-accordion--trailing"
        [hidden]="navTabGroupModel?.is529  || navTabGroupModel?.isExternalFund">
      <h2>
        <button type="button" class="distribution-sec c11n-accordion__trigger c11n-accordion__trigger-medium"
          aria-expanded="false"
          title="show more"
          (click)="toggleAccordion('distributions')">
            <span class="c11n-accordion__trigger-items container">
                <span class="c11n-accordion__heading-group">
                    <span class="c11n-accordion__heading">
                        <span>Distributions</span>
                    </span>
                </span>

                <span class="c11n-accordion__icon">
                    <svg id="distributions-caret-down" class="c11n-caret-down-small" aria-hidden="true">
                        <use xlink:href="#caret-down-small"></use>
                    </svg>
                    <svg id="distributions-caret-up" class="hidden c11n-caret-up-small" aria-hidden="true">
                        <use xlink:href="#caret-up-small"></use>
                    </svg>
                </span>

            </span>
        </button>
      </h2>
      <div id="distributions-body" class="c11n-accordion__body">
        <div class="c11n-accordion__body-content">
          <div class="c11n-accordion-story-content">
            <div class="c11n-text-md--crop c11n-link--reinforced">
              <distributions></distributions>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fund management -->
    <div class="c11n-accordion c11n-accordion--medium
        c11n-accordion--bold-weight
        c11n-accordion--trailing"
        [hidden]="navTabGroupModel?.isExternalFund">
      <h2>
        <button type="button" class="distribution-sec c11n-accordion__trigger c11n-accordion__trigger-medium"
          aria-expanded="false"
          title="show more"
          (click)="toggleAccordion('fund-management')">
            <span class="c11n-accordion__trigger-items container">
                <span class="c11n-accordion__heading-group">
                    <span class="c11n-accordion__heading">
                        <span>Fund management</span>
                    </span>
                </span>

                <span class="c11n-accordion__icon">
                    <svg id="fund-management-caret-down" class="c11n-caret-down-small" aria-hidden="true">
                        <use xlink:href="#caret-down-small"></use>
                    </svg>
                    <svg id="fund-management-caret-up" class="hidden c11n-caret-up-small" aria-hidden="true">
                        <use xlink:href="#caret-up-small"></use>
                    </svg>
                </span>

            </span>
        </button>
      </h2>
      <div id="fund-management-body" class="c11n-accordion__body">
        <div class="c11n-accordion__body-content">
          <div class="c11n-accordion-story-content">
            <div class="c11n-text-md--crop c11n-link--reinforced">
              <fund-management></fund-management>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Proxy voting -->
    <div class="c11n-accordion c11n-accordion--medium
        c11n-accordion--bold-weight
        c11n-accordion--trailing"
        [hidden]="!hasProxyVotingContent">
      <h2>
        <button type="button" class="distribution-sec c11n-accordion__trigger c11n-accordion__trigger-medium"
          aria-expanded="false"
          title="show more"
          (click)="toggleAccordion('proxy-voting')">
            <span class="c11n-accordion__trigger-items container">
                <span class="c11n-accordion__heading-group">
                    <span class="c11n-accordion__heading">
                        <span>Proxy voting</span>
                    </span>
                </span>

                <span class="c11n-accordion__icon">
                    <svg id="proxy-voting-caret-down" class="c11n-caret-down-small" aria-hidden="true">
                        <use xlink:href="#caret-down-small"></use>
                    </svg>
                    <svg id="proxy-voting-caret-up" class="hidden c11n-caret-up-small" aria-hidden="true">
                        <use xlink:href="#caret-up-small"></use>
                    </svg>
                </span>

            </span>
        </button>
      </h2>
      <div id="proxy-voting-body" class="c11n-accordion__body">
        <div class="c11n-accordion__body-content">
          <div class="c11n-accordion-story-content">
            <div class="c11n-text-md--crop c11n-link--reinforced">
              <proxy-voting [proxyVotingContent]="proxyVotingContent"></proxy-voting>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fund literature -->
    <div class="c11n-accordion c11n-accordion--medium
        c11n-accordion--bold-weight
        c11n-accordion--trailing"
        [hidden]="navTabGroupModel?.is529 || navTabGroupModel?.isExternalFund" *ngIf="!navTabGroupModel?.is529">
      <h2>
        <button type="button" class="distribution-sec c11n-accordion__trigger c11n-accordion__trigger-medium"
          aria-expanded="false"
          title="show more"
          (click)="toggleAccordion('fund-literature')">
            <span class="c11n-accordion__trigger-items container">
                <span class="c11n-accordion__heading-group">
                    <span class="c11n-accordion__heading">
                        <span>Fund literature</span>
                    </span>
                </span>

                <span class="c11n-accordion__icon">
                    <svg id="fund-literature-caret-down" class="c11n-caret-down-small" aria-hidden="true">
                        <use xlink:href="#caret-down-small"></use>
                    </svg>
                    <svg id="fund-literature-caret-up" class="hidden c11n-caret-up-small" aria-hidden="true">
                        <use xlink:href="#caret-up-small"></use>
                    </svg>
                </span>

            </span>
        </button>
      </h2>
      <div id="fund-literature-body" class="c11n-accordion__body">
        <div class="c11n-accordion__body-content">
          <div class="c11n-accordion-story-content">
            <div class="c11n-text-md--crop c11n-link--reinforced">
              <fund-literature></fund-literature>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>